import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Param } from "../context/Param";
import { optionsFromArguments } from "../util/Defaults";
import { readOnly } from "../util/Interface";
import { ToneAudioNode } from "./ToneAudioNode";
/**
 * A thin wrapper around the Native Web Audio GainNode.
 * The GainNode is a basic building block of the Web Audio
 * API and is useful for routing audio and adjusting gains.
 * @category Core
 * @example
 * return Tone.Offline(() => {
 * 	const gainNode = new Tone.Gain(0).toDestination();
 * 	const osc = new Tone.Oscillator(30).connect(gainNode).start();
 * 	gainNode.gain.rampTo(1, 0.1);
 * 	gainNode.gain.rampTo(0, 0.4, 0.2);
 * }, 0.7, 1);
 */

export var Gain = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Gain, _ToneAudioNode);

  var _super = _createSuper(Gain);

  function Gain() {
    var _this;

    _classCallCheck(this, Gain);

    _this = _super.call(this, optionsFromArguments(Gain.getDefaults(), arguments, ["gain", "units"]));
    _this.name = "Gain";
    /**
     * The wrapped GainNode.
     */

    _this._gainNode = _this.context.createGain(); // input = output

    _this.input = _this._gainNode;
    _this.output = _this._gainNode;
    var options = optionsFromArguments(Gain.getDefaults(), arguments, ["gain", "units"]);
    _this.gain = new Param({
      context: _this.context,
      convert: options.convert,
      param: _this._gainNode.gain,
      units: options.units,
      value: options.gain,
      minValue: options.minValue,
      maxValue: options.maxValue
    });
    readOnly(_assertThisInitialized(_this), "gain");
    return _this;
  }

  _createClass(Gain, [{
    key: "dispose",

    /**
     * Clean up.
     */
    value: function dispose() {
      _get(_getPrototypeOf(Gain.prototype), "dispose", this).call(this);

      this._gainNode.disconnect();

      this.gain.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        convert: true,
        gain: 1,
        units: "gain"
      });
    }
  }]);

  return Gain;
}(ToneAudioNode);